export const slug = "saturday-queue";
export const title = "Saturday Queue";
export const section = "Core";
export const content = `
# Saturday Queue

The Saturday Queue page manages real-time check-ins and service flow on distribution day.

## Queue Statuses

Every client in the queue is in one of three states:

- **In Queue** — the client has checked in and is waiting to be called.
- **Serving** — a staff member has called this client forward and is actively helping them.
- **Done** — service is complete; the visit has been recorded.

## Checking Clients In

Clients can check in themselves from the kiosk or client portal. Staff can also use the **Add to Queue** button to check someone in manually — useful when a client arrives without a phone.

## Wait-Time Tracking

The **Est. Wait** column shows each client's approximate wait time based on their position and the average service time. This updates automatically as clients move through the queue.

## Real-Time Updates

The queue page uses live updates — you do not need to refresh. When a new client checks in or a status changes on another device, the list updates within a few seconds.

## Moving Clients Through the Queue

- Click **Call Next** or the individual client's **Serve** button to move them from *In Queue* to *Serving*.
- Click **Done** when service is complete; this records the visit and removes the client from the active queue.
- Use **Send Back** if a client steps away and needs to return to the waiting list.

## Pausing the Kiosk Countdown

If you need to temporarily stop new clients from checking in (e.g., you've reached capacity), toggle **Pause Kiosk** in the top-right. The kiosk will show a "Please wait" message to clients until you unpause.
`;
